import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(protected router: Router, private auth: AngularFireAuth) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.checkAuth(state.url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.checkAuth(state.url);
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> {
    // canMatch fires before the navigation is committed, so router state is
    // stale. Read the browser URL directly to preserve query params (notably
    // ?invite_token=... from the invite email flow).
    const browserUrl =
      typeof window !== 'undefined'
        ? window.location.pathname + window.location.search
        : '/' + segments.map((s) => s.path).join('/');
    return this.checkAuth(browserUrl);
  }

  private checkAuth(redirectUrl: string): Observable<boolean> {
    return this.auth.user.pipe(
      take(1),
      map((user) => {
        if (user) {
          return true;
        }
        this.router.navigate(['/auth/login'], {
          queryParams: { next: redirectUrl },
        });
        return false;
      })
    );
  }
}
